import { useContext, useEffect, useState } from 'react';
import useBackdrop from '../hooks/useBackdrop';
import useDialog from '../hooks/useDialog';
import useSnackbar from '../hooks/useSnackbar';
import { DataGrid, type GridColDef } from '@mui/x-data-grid';
import { Outlet } from 'react-router';
import PageBaseLayout from '../layouts/PageBaseLayout';
import { supabase } from '../supabase-client';
import type { Invoice } from '../models/types';
import {
  Button,
  IconButton,
  ToggleButton,
  ToggleButtonGroup,
} from '@mui/material';
import moment from 'moment';
import { AuthContext } from '../contexts/AuthContext';
import InvoiceViewerDialog from '../components/InvoiceViewerDialog';
import { getInvoiceFile } from '../fetchFns';

export default function TrandingAdminInvoices({
  invoiceId,
}: {
  invoiceId?: string;
}) {
  const backdrop = useBackdrop();
  const snackbar = useSnackbar();
  const dialog = useDialog();
  const authCtx = useContext(AuthContext);
  const [invoices, setInvoices] = useState<any[]>(
    // <WithdrawalRequest[]>
    [],
  );
  const [selectedFilter, setSelectedFilter] = useState('all');

  const handleChangeFilter = (
    event: React.MouseEvent<HTMLElement>,
    newValue: string,
  ) => {
    setSelectedFilter(newValue);
  };

  // const handleUpdateWithdrawalRequest = (
  //   id: number,
  //   newStatus: 'pending' | 'completed' | 'rejected',
  //   newAmount: number,
  //   newRemarks: string | undefined,
  // ) => {
  //   setInvoices((oldWithdrawalRequests) => {
  //     const withdrawalRequest = oldWithdrawalRequests.find(
  //       (wr) => wr.id === id,
  //     );

  //     if (!withdrawalRequest)
  //       throw new Error('Could not find withdrawal request. Please refresh.');

  //     withdrawalRequest.status = newStatus;
  //     withdrawalRequest.amount = Math.abs(newAmount) * -1;
  //     withdrawalRequest.remarks = newRemarks ?? '';

  //     const newWithdrawalRequests = oldWithdrawalRequests.filter(
  //       (wr) => wr.id !== withdrawalRequest.id,
  //     );

  //     newWithdrawalRequests.push(withdrawalRequest);
  //     newWithdrawalRequests.sort(
  //       (a, b) =>
  //         new Date(a.created_at).getTime() - new Date(b.created_at).getTime(),
  //     );
  //     return newWithdrawalRequests;
  //   });
  // };

  const columns: GridColDef<Invoice>[] = [
    {
      field: 'actions',
      headerName: 'Action',
      type: 'actions',
      width: 100,
      getActions: (params) => [
        <IconButton
          aria-label="mark-as-read"
          onClick={async () => {
            backdrop.handleBackdropOpen();
            dialog.handleDialogOpen(<>s</>, 'Send Notification');
            try {
              const { error } = await supabase
                .schema('app')
                .from('notifications')
                .delete()
                .eq('id', params.row.invoice_id);

              if (error) {
                console.error('Error deleting notification:', error);
                throw error;
              }

              // setNotifications((oldNotifications) =>
              //   oldNotifications.filter((n) => n.id !== params.row.id),
              // );
              snackbar.handleSnackbarOpen(
                'Notification marked as read',
                'success',
              );
            } catch (error) {
              const errorCast = error as Error;
              console.error(errorCast.stack);
              snackbar.handleSnackbarOpen(errorCast.message, 'error');
            }
            backdrop.handleBackdropClose();
          }}>
          s{/* <SendIcon color="primary" /> */}
        </IconButton>,
      ],
      //   const requestNotPending = param.row.status !== 'pending';

      //   return (
      //     <Box>
      //       <IconButton
      //         disabled={requestNotPending}
      //         aria-label="approve"
      //         onClick={() => {
      //           dialog.handleDialogOpen(
      //             <ProcessWithdrawalRequestDialog
      //               handleUpdateWithdrawalRequest={
      //                 handleUpdateWithdrawalRequest
      //               }
      //               withdrawalRequestId={param.row.id}
      //               amount={param.row.amount}
      //               newStatus="completed"
      //             />,
      //             `Approve Withdrawal Request - ${param.row.id}`,
      //           );
      //         }}>
      //         <DoneIcon color={requestNotPending ? 'disabled' : 'success'} />
      //       </IconButton>
      //       <IconButton
      //         disabled={requestNotPending}
      //         aria-label="reject"
      //         onClick={() => {
      //           dialog.handleDialogOpen(
      //             <ProcessWithdrawalRequestDialog
      //               handleUpdateWithdrawalRequest={
      //                 handleUpdateWithdrawalRequest
      //               }
      //               withdrawalRequestId={param.row.id}
      //               amount={param.row.amount}
      //               newStatus="rejected"
      //             />,
      //             `Reject Withdrawal Request - ${param.row.id}`,
      //           );
      //         }}>
      //         <ClearIcon color={requestNotPending ? 'disabled' : 'error'} />
      //       </IconButton>
      //     </Box>
      //   );
    },
    {
      field: 'invoice_id',
      headerName: 'Invoice ID',
      width: 140,
      type: 'actions',
      getActions: (params) => [
        <Button
          size="small"
          onClick={async () => {
            backdrop.handleBackdropOpen();
            const response = await getInvoiceFile(params.row.invoice_id);

            const blob = await response.blob();
            const url = URL.createObjectURL(blob);

            dialog.handleDialogOpen(
              <InvoiceViewerDialog invoicePdfUrl={url} />,
              `Invoice ${params.id}`,
            );
            backdrop.handleBackdropClose();
          }}>
          {params.id}
        </Button>,
      ],
    },
    {
      field: 'date',
      headerName: 'Date',
      type: 'date',
      valueGetter: (value) => new Date(value),
      valueFormatter: (value) => moment(value).format('YYYY-MM-DD'),
      width: 100,
    },
    {
      field: 'merchant_name',
      headerName: 'Brand',
      width: 160,
      type: 'string',
    } as GridColDef<Invoice>,
    {
      field: 'status',
      headerName: 'Status',
      width: 80,
      type: 'singleSelect',
      valueOptions: ['unpaid', 'paid', 'void'],
    },
    {
      field: 'total_amount',
      headerName: 'Amount',
      width: 90,
      type: 'number',
    },
    {
      field: 'remarks',
      headerName: 'Remarks',
      width: 140,
      type: 'string',
    },
  ];

  const getData = async () => {
    backdrop.handleBackdropOpen();

    try {
      const { data, error } = await supabase
        .schema('admin_backend')
        .from('invoices')
        .select('*');

      if (error) {
        console.error('Error fetching invoices:', error);
        throw error;
      }

      setInvoices(data.map((el) => ({ ...el, id: el.invoice_id })));
    } catch (error) {
      const errorCast = error as Error;
      console.error(errorCast.stack);
      snackbar.handleSnackbarOpen(errorCast.message, 'error');
    }

    backdrop.handleBackdropClose();
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <PageBaseLayout title="Invoices">
      {/* <ToggleButtonGroup
        size="small"
        color="primary"
        value={selectedFilter}
        exclusive
        onChange={handleChangeFilter}
        aria-label="Platform">
        <ToggleButton value="all">All</ToggleButton>
        <ToggleButton value="earning">Unpaid</ToggleButton>
        <ToggleButton value="withdrawal">Paid</ToggleButton>
        <ToggleButton value="withdrawal">Void</ToggleButton>
      </ToggleButtonGroup> */}
      <DataGrid columns={columns} rows={invoices} />
      <Outlet />
    </PageBaseLayout>
  );
}
